import { OrderWithoutPII } from '@getvim/internal-vim-os-sdk/types';

interface TransformedData {
  procedures: Array<{
    label: string;
    value: string;
  }>;
  diagnosis?: {
    label: string;
    value: string;
  };
}

export const getOrderCptIcd = (orders: OrderWithoutPII[]): TransformedData => {
  const order = orders[0];

  if (!order) {
    return {
      procedures: [],
    };
  }

  const procedures =
    order.procedureCodes?.procedureCodes?.map((validCpt) => ({
      label: validCpt.description ?? '',
      value: validCpt.code ?? '',
    })) ?? [];

  const assessment = order.assessments?.assessments?.[0];
  const diagnosis = assessment
    ? {
        label: assessment.description ?? '',
        value: assessment.code ?? '',
      }
    : undefined;

  return {
    procedures,
    diagnosis,
  };
};

export interface OrderCreatedEventPayload {
  type: string;
  payload: {
    order: {
      id: string;
      icd: {
        name: string;
        code: string;
      }[];
      cpts: {
        name: string;
        code: string;
      }[];
      encounterId: string;
      createdDate: string;
      patient: {
        patientId: string;
        vimPatientId: string;
      };
    };
  };
}

export const getOrderCreatedCptIcd = (
  orderCreatedEvent: OrderCreatedEventPayload,
): TransformedData => {
  const { payload } = orderCreatedEvent;
  const { order } = payload;
  const { icd, cpts } = order;
  const procedures = cpts?.map((cpt) => ({
    label: cpt.name,
    value: cpt.code,
  }));
  const diagnosis = icd?.map((icd) => ({
    label: icd.name,
    value: icd.code,
  }));
  return {
    procedures,
    diagnosis: diagnosis?.length > 0 ? diagnosis[0] : undefined,
  };
};
